<template>
    <div class="insurance">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon" @createForm="dialog.state=true" ></myBreadCrumb> -->
        <create-dialog></create-dialog>

        <!-- <create-dialog-health-insurance ref="createHealthInsurance" @needFetch="fetchData"></create-dialog-health-insurance> -->
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Danh sách bảo hiểm
                <v-spacer></v-spacer>

                <!-- Month Picker -->
                <month-picker v-model="month" label="Chọn tháng" width="10rem" outlined dense hide-details class="mx-2"></month-picker>

                <!-- Refresh Button -->
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block
                        style="width: 40px !important; height: 40px; padding: 0px;">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>

                <v-divider vertical class="mx-4"></v-divider>

                <!-- Actions -->
                <v-btn color="primary" class="mx-1 rounded-lg font-weight-bold" @click="openEmployeeInsuranceDialog(null)" height="40">
                    <v-icon left>mdi-plus</v-icon> Thêm mới
                </v-btn>
                
                <!-- Import Excel button -->
                <v-btn color="teal darken-2" dark class="mx-1 rounded-lg font-weight-bold" @click="dialogImport = true" height="40">
                    <v-icon left>mdi-upload-outline</v-icon> Import Excel
                </v-btn>

                <excel-button class="mx-1" @click="exportPrompt = true" />
                <export-prompt url="insurances" v-model="exportPrompt" fileName="BAO_HIEM"></export-prompt>

                <v-divider vertical class="mx-4"></v-divider>

                <data-filter v-model="params" :filter="filter" @fetchData="fetchData"> </data-filter>
            </v-card-title>

            <!-- Statistics & Search Banner -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5"
                style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="teal lighten-4" text-color="teal darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-card-bulleted-outline</v-icon>
                    Tổng số bảo hiểm: <b class="ml-1">{{ data.length }}</b>
                </v-chip>
                <v-spacer></v-spacer>
                <!-- Search Box -->
                <v-text-field style="max-width: 300px; background-color: white;" outlined dense
                    placeholder="Tìm kiếm ..." v-model="search" hide-details="auto" prepend-inner-icon="mdi-magnify"
                    clearable></v-text-field>
            </v-sheet>

            <v-data-table height="calc(100vh - 350px)" fixed-header :headers="headers" :items="data" :search="search"
                :loading="isLoading" loading-text="Đang tải dữ liệu..." class="elevation-0">

                <!-- Employee Code -->
                <template v-slot:[`item.employeeCode`]="{ item }">
                    <v-chip class="font-weight-bold text-caption px-2" color="blue-grey lighten-5"
                        text-color="blue-grey darken-3" small>
                        {{ item.employeeCode }}
                    </v-chip>
                </template>

                <!-- Employee Name -->
                <template v-slot:[`item.employeeName`]="{ item }">
                    <span class="font-weight-bold text-subtitle-2 blue-grey--text text--darken-4">{{ item.employeeName
                        }}</span>
                </template>

                <!-- Has Insurance -->
                <template v-slot:[`item.hasInsurance`]="{ item }">
                    <v-chip :color="item.hasInsurance === 1 ? 'teal lighten-5' : 'red lighten-5'"
                        :text-color="item.hasInsurance === 1 ? 'teal darken-3' : 'red darken-3'"
                        class="font-weight-bold" small>
                        {{ item.hasInsurance === 1 ? 'Có' : 'Không' }}
                    </v-chip>
                </template>

                <!-- Valid From -->
                <template v-slot:[`item.validFrom`]="{ item }">
                    <span class="font-weight-medium" v-if="item.validFrom">{{ $formatter.formatDate(item.validFrom)
                        }}</span>
                    <span class="grey--text text-caption" v-else>---</span>
                </template>

                <!-- Valid To -->
                <template v-slot:[`item.validTo`]="{ item }">
                    <span class="font-weight-medium"
                        v-if="item.validTo && item.validTo.substring(0, 4) !== '2100'">{{
                            $formatter.formatDate(item.validTo) }}</span>
                    <span class="grey--text text-caption" v-else>Vô thời hạn</span>
                </template>

                <!-- Insurance Number -->
                <template v-slot:[`item.insuranceNumber`]="{ item }">
                    <span class="font-weight-medium blue-grey--text text--darken-3">{{ item.insuranceNumber || '---'
                        }}</span>
                </template>

                <!-- Note -->
                <template v-slot:[`item.note`]="{ item }">
                    <span class="text-caption grey--text text--darken-2">{{ item.note || '---' }}</span>
                </template>

                <!-- Actions -->
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-center align-center">
                        <v-btn icon color="primary" @click="showHistory(item)" title="Xem lịch sử">
                            <v-icon>mdi-history</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <!-- ************** HISTORY DIALOG *************** -->
        <v-dialog v-model="dialogHistory" max-width="950px" scrollable>
            <v-card class="rounded-xl">
                <v-card-title class="headline font-weight-bold pt-4 pb-2 px-6 d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-history</v-icon>
                    Lịch sử đóng BHXH: {{ selectedEmployeeName }} ({{ selectedEmployeeCode }})
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogHistory = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pa-6">
                    <v-data-table :headers="historyHeaders" :items="historyData" :loading="historyLoading"
                        loading-text="Đang tải lịch sử đóng BHXH..." hide-default-footer disable-pagination
                        class="elevation-0 border rounded-lg">

                        <!-- Actions -->
                        <template v-slot:[`item.actions`]="{ item }">
                            <div class="d-flex justify-center align-center">
                                <v-btn icon color="primary" small class="mr-1" @click="openEmployeeInsuranceDialog(item)" title="Chỉnh sửa">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                                <v-btn icon color="error" small @click="deleteHistoryItem(item)" title="Xóa lịch sử">
                                    <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                            </div>
                        </template>

                        <!-- Month -->
                        <template v-slot:[`item.month`]="{ item }">
                            <span class="font-weight-bold">{{ item.month ? $formatter.formatDate(item.month, 'MM/YYYY')
                                : '---' }}</span>
                        </template>

                        <!-- Has Insurance -->
                        <template v-slot:[`item.hasInsurance`]="{ item }">
                            <v-chip :color="item.hasInsurance === 1 ? 'teal lighten-5' : 'red lighten-5'"
                                :text-color="item.hasInsurance === 1 ? 'teal darken-3' : 'red darken-3'"
                                class="font-weight-bold" small>
                                {{ item.hasInsurance === 1 ? 'Có' : 'Không' }}
                            </v-chip>
                        </template>

                        <!-- Valid From -->
                        <template v-slot:[`item.validFrom`]="{ item }">
                            <span class="font-weight-medium" v-if="item.validFrom">{{
                                $formatter.formatDate(item.validFrom) }}</span>
                            <span class="grey--text text-caption" v-else>---</span>
                        </template>

                        <!-- Valid To -->
                        <template v-slot:[`item.validTo`]="{ item }">
                            <span class="font-weight-medium"
                                v-if="item.validTo && item.validTo.substring(0, 4) !== '2100'">{{
                                    $formatter.formatDate(item.validTo) }}</span>
                            <span class="grey--text text-caption" v-else>Vô thời hạn</span>
                        </template>

                        <!-- Insurance Number -->
                        <template v-slot:[`item.insuranceNumber`]="{ item }">
                            <span class="font-weight-medium blue-grey--text text--darken-3">{{ item.insuranceNumber ||
                                '---' }}</span>
                        </template>

                        <!-- Note -->
                        <template v-slot:[`item.note`]="{ item }">
                            <span class="text-caption grey--text text--darken-2">{{ item.note || '---' }}</span>
                        </template>

                        <!-- Created At -->
                        <template v-slot:[`item.createdAt`]="{ item }">
                            <span class="text-caption grey--text text--darken-1" v-if="item.createdAt">
                                {{ $formatter.formatDate(item.createdAt, 'DD/MM/YYYY HH:mm') }}
                            </span>
                            <span class="grey--text text-caption" v-else>---</span>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-2" class="rounded-lg font-weight-bold px-4 black--text" depressed
                        @click="dialogHistory = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ************** DELETE HISTORY CONFIRMATION *************** -->
        <v-dialog v-model="dialogDeleteHistory" max-width="450px" style="z-index: 10000 !important;">
            <v-card class="rounded-xl pa-4">
                <v-card-title class="text-h6 font-weight-bold justify-center text-center pb-2">
                    Bạn có chắc muốn xoá lịch sử này?
                </v-card-title>
                <v-card-text class="text-body-2 text-center grey--text text--darken-1">
                    Hành động này không thể hoàn tác. Dữ liệu lịch sử bảo hiểm này sẽ bị xóa khỏi hệ thống.
                </v-card-text>
                <v-card-actions class="justify-center mt-2">
                    <v-btn color="grey lighten-2" class="rounded-lg font-weight-bold px-4 black--text" depressed
                        @click="dialogDeleteHistory = false">Thoát</v-btn>
                    <v-btn color="red darken-1" class="rounded-lg font-weight-bold px-4" dark depressed
                        @click="cfmDeleteHistoryItem">Đồng ý</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ************** EMPLOYEE INSURANCE DIALOG (CREATE/EDIT) *************** -->
        <v-dialog v-model="employeeInsuranceDialog" max-width="500px" persistent style="z-index: 10001 !important;">
            <v-card class="rounded-xl">
                <v-card-title class="font-weight-bold pt-4 pb-2 px-6 d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-shield-plus-outline</v-icon>
                    {{ employeeInsuranceForm.id ? 'Cập nhật lịch sử BHXH' : 'Thêm lịch sử BHXH' }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="employeeInsuranceDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                
                <v-card-text class="pa-6">
                    <v-form ref="employeeInsuranceForm" v-model="isInsuranceFormValid">
                        <v-row>
                            <!-- Employee Select (only enabled when creating) -->
                            <v-col cols="12" class="py-2" v-if="!employeeInsuranceForm.id">
                                <v-autocomplete
                                    outlined
                                    v-model="employeeInsuranceForm.employeeCode"
                                    :items="employees"
                                    item-value="code"
                                    item-text="name"
                                    label="Chọn nhân viên (MSNS)"
                                    :rules="[v => !!v || 'Vui lòng chọn nhân viên']"
                                    dense
                                    hide-details="auto"
                                    class="rounded-lg"
                                    :filter="(item, queryText) => (item.code.toLowerCase().includes(queryText.toLowerCase()) || item.name.toLowerCase().includes(queryText.toLowerCase()))">
                                    <template v-slot:item="data">
                                        {{ data.item.code }}: {{ data.item.name }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="py-2" v-else>
                                <v-text-field
                                    v-model="employeeInsuranceForm.employeeNameWithCode"
                                    label="Nhân viên"
                                    outlined
                                    dense
                                    disabled
                                    hide-details="auto"
                                    class="rounded-lg">
                                </v-text-field>
                            </v-col>

                            <!-- Has Insurance Checkbox -->
                            <v-col cols="12" class="py-2">
                                <v-checkbox
                                    class="mt-0 pt-0"
                                    hide-details="auto"
                                    v-model="employeeInsuranceForm.hasInsurance"
                                    :true-value="1"
                                    :false-value="0"
                                    label="Tham gia BHXH">
                                </v-checkbox>
                            </v-col>

                            <!-- Insurance Number -->
                            <v-col cols="12" class="py-2">
                                <v-text-field
                                    v-model="employeeInsuranceForm.insuranceNumber"
                                    label="Số sổ BHXH"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    class="rounded-lg">
                                </v-text-field>
                            </v-col>

                            <!-- Valid From -->
                            <v-col cols="12" md="6" class="py-2">
                                <v-text-field
                                    type="date"
                                    v-model="employeeInsuranceForm.validFrom"
                                    label="Hiệu lực từ"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    class="rounded-lg">
                                </v-text-field>
                            </v-col>

                            <!-- Valid To -->
                            <v-col cols="12" md="6" class="py-2">
                                <v-text-field
                                    type="date"
                                    v-model="employeeInsuranceForm.validTo"
                                    label="Hiệu lực đến"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    class="rounded-lg">
                                </v-text-field>
                            </v-col>

                            <!-- Note -->
                            <v-col cols="12" class="py-2">
                                <v-text-field
                                    v-model="employeeInsuranceForm.note"
                                    label="Ghi chú"
                                    dense
                                    outlined
                                    hide-details="auto"
                                    class="rounded-lg">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                
                <v-divider></v-divider>
                <v-card-actions class="px-6 pb-4 pt-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-2" class="rounded-lg font-weight-bold px-4 black--text" depressed @click="employeeInsuranceDialog = false">Hủy</v-btn>
                    <v-btn color="teal darken-4" dark class="rounded-lg font-weight-bold px-4" depressed @click="saveEmployeeInsurance" :disabled="!isInsuranceFormValid">Lưu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ************** IMPORT EXCEL DIALOG *************** -->
        <v-dialog v-model="dialogImport" max-width="900px" scrollable>
            <v-card class="rounded-xl" :loading="importLoading">
                <v-card-title class="headline font-weight-bold pt-4 pb-2 px-6 d-flex align-center">
                    <v-icon color="teal darken-2" class="mr-2">mdi-upload-outline</v-icon>
                    Import danh sách bảo hiểm hàng tháng
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogImport = false, importFile = null, previewData = []">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text class="pa-6">
                    <div class="mb-4 d-flex align-center">
                        <span class="text-body-2 font-weight-medium mr-4">Chọn tháng:</span>
                        <month-picker v-model="month" label="Chọn tháng" width="10rem" outlined dense hide-details></month-picker>
                    </div>

                    <v-file-input
                        v-model="importFile"
                        accept=".xlsx"
                        label="Chọn tệp Excel (.xlsx)"
                        outlined
                        dense
                        prepend-icon="mdi-file-excel-outline"
                        @change="handleImportFileChange"
                        hide-details
                        class="mb-4">
                    </v-file-input>

                    <div class="mb-4 d-flex justify-end">
                        <v-btn text small color="primary" class="font-weight-bold" @click="downloadTemplate">
                            <v-icon left small>mdi-download</v-icon> Tải file Excel mẫu
                        </v-btn>
                    </div>

                    <div v-if="previewData.length > 0">
                        <div class="subtitle-2 font-weight-bold mb-2 teal--text text--darken-4">
                            Xem trước dữ liệu import (Tối đa 5 dòng đầu):
                        </div>
                        <v-simple-table dense class="border rounded-lg mb-4">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left font-weight-bold">MSNS</th>
                                        <th class="text-left font-weight-bold">Họ và tên</th>
                                        <th class="text-center font-weight-bold">Đóng BH</th>
                                        <th class="text-left font-weight-bold">Tháng</th>
                                        <th class="text-left font-weight-bold">Số sổ BH</th>
                                        <th class="text-left font-weight-bold">Ghi chú</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(row, idx) in previewData" :key="idx">
                                        <td>{{ row.employeeCode }}</td>
                                        <td>{{ row.employeeName }}</td>
                                        <td class="text-center">
                                            <v-chip :color="row.hasInsurance === 1 ? 'teal lighten-5' : 'red lighten-5'"
                                                :text-color="row.hasInsurance === 1 ? 'teal darken-3' : 'red darken-3'"
                                                class="font-weight-bold" x-small>
                                                {{ row.hasInsurance === 1 ? 'Có' : 'Không' }}
                                            </v-chip>
                                        </td>
                                        <td>{{ row.month ? $formatter.formatDate(row.month, 'MM/YYYY') : '---' }}</td>
                                        <td>{{ row.insuranceNumber || '---' }}</td>
                                        <td>{{ row.note || '---' }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <div class="text-caption grey--text text--darken-2">
                            * Hệ thống nhận diện được tổng cộng <b>{{ parsedRowsCount }}</b> dòng dữ liệu từ file.
                        </div>
                    </div>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-2" class="rounded-lg font-weight-bold px-4 black--text" depressed @click="dialogImport = false, importFile = null, previewData = []">Thoát</v-btn>
                    <v-btn color="teal darken-2" dark class="rounded-lg font-weight-bold px-4" depressed :disabled="importDataList.length === 0" @click="submitImport">Import dữ liệu</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import CreateInsurance from './Create';
import * as moment from "moment/moment";
import DataFilter from '@/components/DataFilter';
import EventBus from "@/components/services/EventBus";
import * as XLSX from "xlsx";

export default {
    name: "Insurance",
    components: {
        "create-dialog": CreateInsurance,
        "data-filter": DataFilter
    },
    watch: {
        month() {
            this.fetchData();
        },
        options: {
            handler(val) {
                this.fetchData();
            },
            deep: true,
        },
    },
    data() {
        return {
            ROOT_URL: "EmployeeMonthInsurances/overview",
            DEPARTMENT_URL: "Departments",
            month: moment().format("YYYY-MM"),

            exportPrompt: false,
            params: {
                sortBy: [],
                sortDesc: [],
                page: "",
                itemsPerPage: "",
                searchs: [],
                searchAttrs: [],
                fromOn: "",
                from: "",
                to: ""
            },

            filter: {
                menu: false,
                search: "",
                searchAttr: "EmployeeName",
                department: "",
                from: new Date().toISOString().substr(0, 10),
                to: new Date().toISOString().substr(0, 10),
                fromOns: [
                    { text: "Từ ngày", value: "ValidFrom" },
                    { text: "Đến ngày", value: "ValidTo" }
                ],
                fromOn: undefined,
                searchAttrs: [
                    { text: "Tên nhân viên", value: "EmployeeName" },
                    { text: "MSNV", value: "EmployeeCode" },
                ],
                FilterAttrs: [
                    { text: "Phòng", items: [] }
                ],
                FilterOn: ["DepartmentCode"],
            },

            dialog: {
                state: false,
                item: undefined,
            },
            dialogHistory: false,
            historyLoading: false,
            historyData: [],
            selectedEmployeeName: "",
            selectedEmployeeCode: "",
            dialogDeleteHistory: false,
            targetHistoryItem: {},

            // Employee Insurance creation properties
            employeeInsuranceDialog: false,
            isInsuranceFormValid: true,
            employees: [],
            employeeInsuranceForm: {
                id: null,
                employeeCode: '',
                employeeNameWithCode: '',
                hasInsurance: 1,
                insuranceNumber: '',
                validFrom: '',
                validTo: '',
                note: ''
            },
            defaultEmployeeInsuranceForm: {
                id: null,
                employeeCode: '',
                employeeNameWithCode: '',
                hasInsurance: 1,
                insuranceNumber: '',
                validFrom: '',
                validTo: '',
                note: ''
            },

            // Import properties
            dialogImport: false,
            importFile: null,
            importLoading: false,
            previewData: [],
            importDataList: [],
            parsedRowsCount: 0,

            icon: {
                icon: "mdi-plus-thick",
                to: ""
            },

            data: [],
            totalItem: 0,
            search: "",
            options: {},
            isLoading: true,
            headers: [
                { text: 'Lịch sử', value: 'actions', sortable: false, width: "5rem", align: 'center' },
                { text: 'MSNS', align: 'start', sortable: true, value: 'employeeCode' },
                { text: 'Tên nhân viên', align: 'start', sortable: true, value: 'employeeName', width: '15rem' },
                { text: 'Có đóng BH', align: 'center', sortable: true, value: 'hasInsurance' },
                { text: 'Số sổ BH', align: 'start', sortable: true, value: 'insuranceNumber' },
                { text: 'Từ ngày', align: 'center', sortable: true, value: 'validFrom' },
                { text: 'Đến ngày', align: 'center', sortable: true, value: 'validTo' },
                { text: 'Ghi chú', align: 'start', sortable: false, value: 'note' },
            ],
            historyHeaders: [
                { text: 'Thao tác', value: 'actions', sortable: false, width: "6rem", align: 'center' },
                { text: 'Tháng', align: 'start', sortable: false, value: 'month' },
                { text: 'Số sổ BH', align: 'start', sortable: false, value: 'insuranceNumber' },
                { text: 'Có đóng BH', align: 'center', sortable: false, value: 'hasInsurance' },
                { text: 'Từ ngày', align: 'center', sortable: false, value: 'validFrom' },
                { text: 'Đến ngày', align: 'center', sortable: false, value: 'validTo' },
                { text: 'Ghi chú', align: 'start', sortable: false, value: 'note' },
                { text: 'Ngày tạo', align: 'center', sortable: false, value: 'createdAt' },
                { text: 'Người tạo', align: 'start', sortable: false, value: 'createdBy' },
            ],
        }
    },
    methods: {
        messageToast(eventObj) {
            EventBus.$emit('hasMessage', eventObj);
        },
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        closeHandler() {
            this.dialog = { state: false, item: undefined }
        },
        openDialog() {
            this.$root.$emit('openDialog')
        },
        editItem(item) {
            this.$root.$emit('editDialog', item)
        },
        fetchDepartment() {
            return http(this.DEPARTMENT_URL, {
                params: { dropDown: 1 }
            })
                .then(res => {
                    this.filter.FilterAttrs[0] = { text: "Phòng", items: res.data };
                })
                .catch(err => console.log(err))
        },
        fetchEmployees() {
            return http.get("employees/fetch")
                .then(res => {
                    this.employees = res.data.data || res.data || [];
                })
                .catch(err => console.log("Lỗi tải danh sách nhân viên", err));
        },
        fetchData() {
            this.isLoading = true;
            this.params = {
                ...this.params,
                month: this.month,
                sortBy: this.options.sortBy,
                sortDesc: this.options.sortDesc,
                page: this.options.page,
                itemsPerPage: this.options.itemsPerPage,
            };

            return http.get(this.ROOT_URL, {
                params: this.params
            })
                .then(res => {
                    this.isLoading = false;
                    this.data = res.data.data || res.data.items || res.data || [];
                })
                .catch(err => {
                    this.isLoading = false;
                    throw err;
                });
        },
        showHistory(item) {
            this.selectedEmployeeName = item.employeeName;
            this.selectedEmployeeCode = item.employeeCode;
            this.historyData = [];
            this.dialogHistory = true;
            this.refreshHistory();
        },
        refreshHistory() {
            this.historyLoading = true;
            http.get("employeeMonthInsurances/by-employee/" + this.selectedEmployeeCode)
                .then(res => {
                    this.historyData = res.data.data || res.data || [];
                    this.historyLoading = false;
                })
                .catch(err => {
                    console.error("Lỗi khi tải lịch sử bảo hiểm", err);
                    this.historyLoading = false;
                });
        },
        deleteHistoryItem(item) {
            this.dialogDeleteHistory = true;
            this.targetHistoryItem = item;
        },
        cfmDeleteHistoryItem() {
            http.delete("employeeMonthInsurances/" + this.targetHistoryItem.id)
                .then(res => {
                    let eventObj = {
                        color: "success",
                        message: "Xóa dữ liệu lịch sử thành công",
                        toast: true,
                    };
                    this.messageToast(eventObj);
                    this.dialogDeleteHistory = false;
                    this.refreshHistory();
                    this.fetchData();
                })
                .catch(err => {
                    console.error("Lỗi khi xóa dữ liệu lịch sử", err);
                });
        },

        // Creation / Edit handler matching Employee's CreateV2 design
        openEmployeeInsuranceDialog(item) {
            if (this.$refs.employeeInsuranceForm) {
                this.$refs.employeeInsuranceForm.resetValidation();
            }
            
            if (item) {
                this.employeeInsuranceForm = {
                    id: item.id,
                    employeeCode: item.employeeCode,
                    employeeNameWithCode: `${item.employeeCode} - ${item.employeeName || selectedEmployeeName}`,
                    hasInsurance: item.hasInsurance === 1 ? 1 : 0,
                    insuranceNumber: item.insuranceNumber || '',
                    validFrom: item.validFrom ? moment(item.validFrom).format('YYYY-MM-DD') : '',
                    validTo: item.validTo && item.validTo.substring(0, 4) !== '2100' ? moment(item.validTo).format('YYYY-MM-DD') : '',
                    note: item.note || ''
                };
            } else {
                this.employeeInsuranceForm = {
                    id: null,
                    employeeCode: '',
                    employeeNameWithCode: '',
                    hasInsurance: 1,
                    insuranceNumber: '',
                    validFrom: moment(this.month, "YYYY-MM").startOf('month').format('YYYY-MM-DD'),
                    validTo: '',
                    note: ''
                };
            }
            this.employeeInsuranceDialog = true;
        },
        saveEmployeeInsurance() {
            if (this.$refs.employeeInsuranceForm && !this.$refs.employeeInsuranceForm.validate()) {
                return;
            }

            const payload = {
                EmployeeCode: this.employeeInsuranceForm.employeeCode,
                HasInsurance: this.employeeInsuranceForm.hasInsurance ? 1 : 0,
                ValidFrom: this.employeeInsuranceForm.validFrom || null,
                ValidTo: this.employeeInsuranceForm.validTo || null,
                Note: this.employeeInsuranceForm.note || '',
                InsuranceNumber: this.employeeInsuranceForm.insuranceNumber || '',
                Month: moment(this.month, "YYYY-MM").startOf('month').format('YYYY-MM-DD')
            };

            if (this.employeeInsuranceForm.id) {
                payload.id = this.employeeInsuranceForm.id;
                http.put(`employeeMonthInsurances/${payload.id}`, payload)
                    .then(res => {
                        let eventObj = {
                            color: "success",
                            message: "Cập nhật dữ liệu thành công",
                            toast: true,
                        };
                        this.messageToast(eventObj);
                        this.employeeInsuranceDialog = false;
                        this.fetchData();
                        if (this.dialogHistory) {
                            this.refreshHistory();
                        }
                    })
                    .catch(err => {
                        console.error("Cập nhật thất bại", err);
                    });
            } else {
                http.post("employeeMonthInsurances", payload)
                    .then(res => {
                        let eventObj = {
                            color: "success",
                            message: "Thêm mới dữ liệu thành công",
                            toast: true,
                        };
                        this.messageToast(eventObj);
                        this.employeeInsuranceDialog = false;
                        this.fetchData();
                        if (this.dialogHistory) {
                            this.refreshHistory();
                        }
                    })
                    .catch(err => {
                        console.error("Thêm mới thất bại", err);
                    });
            }
        },

        // Import Excel parsing & submit logic
        handleImportFileChange(file) {
            if (!file) {
                this.previewData = [];
                this.importDataList = [];
                this.parsedRowsCount = 0;
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                    if (json.length < 2) {
                        alert("File Excel không chứa đủ dòng dữ liệu.");
                        return;
                    }

                    const headersRow = json[0];
                    const dataRows = json.slice(1);

                    // Find columns mapping index
                    const mapping = {
                        employeeCode: -1,
                        employeeName: -1,
                        hasInsurance: -1,
                        month: -1,
                        note: -1,
                        validFrom: -1,
                        validTo: -1,
                        insuranceNumber: -1
                    };

                    const cleanString = (str) => {
                        if (!str) return "";
                        return str.toString().trim().toLowerCase()
                            .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                            .replace(/[^a-z0-9]/g, "");
                    };

                    const cleanHeaderList = headersRow.map(h => cleanString(h));

                    const candidates = {
                        employeeCode: ['employeecode', 'manhanvien', 'msns', 'mans', 'manv', 'manhansu', 'ma'],
                        employeeName: ['employeename', 'tennhanvien', 'hovaten', 'tennv', 'hoten', 'nhanvien', 'hotennhanvien'],
                        hasInsurance: ['hasinsurance', 'dongbaohiem', 'codongbh', 'trangthaidongbh', 'dongbh', 'codongbhxh', 'dongbhxh', 'baohiemxahoi', 'baohiem', 'bhxh', 'co', 'trangtai'],
                        month: ['month', 'thang', 'ky', 'kycong', 'thangchot'],
                        note: ['note', 'ghichu', 'mota', 'diengiai'],
                        validFrom: ['validfrom', 'tungay', 'ngaybatdau', 'hieuluctu'],
                        validTo: ['validto', 'denngay', 'ngayketthuc', 'hieulucden'],
                        insuranceNumber: ['insurancenumber', 'sosobh', 'sosobaohiem', 'soso', 'sobhxh', 'sobh']
                    };

                    // Exact matching
                    for (let key in candidates) {
                        for (let colIdx = 0; colIdx < cleanHeaderList.length; colIdx++) {
                            if (candidates[key].includes(cleanHeaderList[colIdx])) {
                                mapping[key] = colIdx;
                                break;
                            }
                        }
                    }

                    // Fallback substring matching for unmatched columns
                    for (let key in candidates) {
                        if (mapping[key] === -1) {
                            for (let colIdx = 0; colIdx < cleanHeaderList.length; colIdx++) {
                                const header = cleanHeaderList[colIdx];
                                const matched = candidates[key].some(candidate => 
                                    header.includes(candidate) || candidate.includes(header)
                                );
                                if (matched) {
                                    const alreadyMapped = Object.values(mapping).includes(colIdx);
                                    if (!alreadyMapped) {
                                        mapping[key] = colIdx;
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    // Parse helpers
                    const parseExcelDate = (val) => {
                        if (!val) return null;
                        if (typeof val === 'number') {
                            const date = new Date((val - 25569) * 86400 * 1000);
                            return moment(date).format('YYYY-MM-DD');
                        }
                        const m = moment(val, ["DD/MM/YYYY", "YYYY-MM-DD", "MM/YYYY", "DD-MM-YYYY"]);
                        return m.isValid() ? m.format('YYYY-MM-DD') : null;
                    };

                    const parseExcelMonth = (val) => {
                        if (!val) return null;
                        if (typeof val === 'number') {
                            const date = new Date((val - 25569) * 86400 * 1000);
                            return moment(date).startOf('month').format('YYYY-MM-DD');
                        }
                        const m = moment(val, ["MM/YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "YYYY-MM", "MM-YYYY"]);
                        return m.isValid() ? m.startOf('month').format('YYYY-MM-DD') : null;
                    };

                    const parseHasInsurance = (val) => {
                        if (val === undefined || val === null) return 0;
                        const strVal = val.toString().trim().toLowerCase();
                        if (strVal === 'co' || strVal === 'có' || strVal === 'yes' || strVal === 'true' || strVal === '1' || val === 1 || val === true || strVal === 'x') {
                            return 1;
                        }
                        const cleaned = cleanString(val);
                        if (cleaned === 'co' || cleaned === 'yes' || cleaned === 'true' || cleaned === '1' || cleaned === 'x') {
                            return 1;
                        }
                        return 0;
                    };

                    const parsedList = [];
                    dataRows.forEach(row => {
                        if (!row || row.length === 0) return;

                        const empCodeVal = mapping.employeeCode !== -1 ? row[mapping.employeeCode] : '';
                        if (!empCodeVal) return;

                        const item = {
                            employeeCode: empCodeVal.toString().trim(),
                            employeeName: mapping.employeeName !== -1 ? (row[mapping.employeeName] || '').toString().trim() : '',
                            hasInsurance: mapping.hasInsurance !== -1 ? parseHasInsurance(row[mapping.hasInsurance]) : 0,
                            month: mapping.month !== -1 ? parseExcelMonth(row[mapping.month]) : moment(this.month, "YYYY-MM").startOf('month').format('YYYY-MM-DD'),
                            createdAt: moment().format('YYYY-MM-DDTHH:mm:ss'),
                            note: mapping.note !== -1 ? (row[mapping.note] || '').toString().trim() : '',
                            validFrom: mapping.validFrom !== -1 ? parseExcelDate(row[mapping.validFrom]) : null,
                            validTo: mapping.validTo !== -1 ? parseExcelDate(row[mapping.validTo]) : null,
                            insuranceNumber: mapping.insuranceNumber !== -1 ? (row[mapping.insuranceNumber] || '').toString().trim() : ''
                        };

                        parsedList.push(item);
                    });

                    this.importDataList = parsedList;
                    this.parsedRowsCount = parsedList.length;
                    this.previewData = parsedList.slice(0, 5);
                } catch (error) {
                    console.error("Lỗi khi đọc file excel", error);
                    alert("Có lỗi xảy ra khi phân tích file Excel. Vui lòng kiểm tra lại định dạng file.");
                }
            };
            reader.readAsArrayBuffer(file);
        },

        submitImport() {
            if (this.importDataList.length === 0) {
                alert("Không có dữ liệu hợp lệ để import.");
                return;
            }

            this.importLoading = true;
            const payload = {
                ImportData: this.importDataList
            };

            http.post("EmployeeMonthInsurances/import/v2", payload, {
                params: {
                    month: this.month
                }
            })
                .then(res => {
                    let eventObj = {
                        color: "success",
                        message: "Import dữ liệu bảo hiểm thành công!",
                        toast: true,
                    };
                    this.messageToast(eventObj);
                    this.dialogImport = false;
                    this.importFile = null;
                    this.previewData = [];
                    this.importDataList = [];
                    this.parsedRowsCount = 0;
                    this.fetchData();
                })
                .catch(err => {
                    console.error("Lỗi khi import excel", err);
                    alert("Import dữ liệu thất bại. Vui lòng thử lại.");
                })
                .finally(() => {
                    this.importLoading = false;
                });
        },

        downloadTemplate() {
            const headers = [
                "MSNS", 
                "Họ và tên", 
                "Có đóng BH", 
                "Tháng", 
                "Số sổ BH", 
                "Ghi chú"
            ];
            
            const sampleData = [
                headers,
                ["NV001", "Nguyễn Văn A", "Có", "07/2026", "123456789", "Đóng mới"],
                ["NV002", "Trần Thị B", "Không", "07/2026", "", "Không đủ điều kiện"]
            ];
            
            const worksheet = XLSX.utils.aoa_to_sheet(sampleData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
            
            XLSX.writeFile(workbook, "TEMPLATE_IMPORT_BAO_HIEM.xlsx");
        }
    },
    created() {
        this.fetchData();
        this.fetchDepartment();
        this.fetchEmployees();
    }
}
</script>